/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { COMMON: de },
  'el-GR': { COMMON: el },
  'en-US': { COMMON: en },
  'es-ES': { COMMON: es },
  'fi-FI': { COMMON: fi },
  'fr-FR': { COMMON: fr },
  'it-IT': { COMMON: it },
  'pl-PL': { COMMON: pl },
  'pt-PT': { COMMON: pt }
};
